import isNumber from './isNumber';
import replaceCommas from './replaceCommas';

export default (value: string): number =>
  isNumber(value) ? replaceCommas(value) : 0;
